const clearInvitationError = {
  name: 'CLEAR_INVITATION_ERROR'
};

const clearUpdateUserError = {
  name: 'CLEAR_UPDATE_USER_ERROR'
};

const clearOrderDetailsReportError = {
  name: 'CLEAR_ORDER_DETAILS_REPORT_ERROR'
};

export const requestsActions = {
  clearInvitationError,
  clearUpdateUserError,
  clearOrderDetailsReportError
};
